import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { Plus, ChevronDown } from 'lucide-react'
import { useLocationContext } from '@/components/layout/LocationLayout'
import { useLocationAssignments } from '@/hooks/usePricing'
import { mapAssignmentRow } from '@/types/pricing'
import { PolicyStackView } from './PolicyStackView'
import { AssignPolicyDialog } from './AssignPolicyDialog'
import { RateSheetPreview } from './RateSheetPreview'

export function LocationPricingTab() {
  const { locationId } = useLocationContext()
  const { data: rawAssignments } = useLocationAssignments(locationId)
  const [showAssignDialog, setShowAssignDialog] = useState(false)
  const [rateSheetOpen, setRateSheetOpen] = useState(false)

  const assignments = (rawAssignments ?? []).map(mapAssignmentRow)

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Pricing Stack</CardTitle>
              <CardDescription>
                Policies assigned to this location, ordered by priority. The highest-priority
                active policy wins for each service on a given day.
              </CardDescription>
            </div>
            <Button onClick={() => setShowAssignDialog(true)}>
              <Plus className="mr-2 h-4 w-4" />
              Assign Policy
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <PolicyStackView locationId={locationId} />
        </CardContent>
      </Card>

      <Card>
        <Collapsible open={rateSheetOpen} onOpenChange={setRateSheetOpen}>
          <CardHeader>
            <CollapsibleTrigger className="flex items-center justify-between w-full">
              <div className="text-left">
                <CardTitle>Current Rate Sheet</CardTitle>
                <CardDescription>
                  Preview resolved rates for this location on a given date.
                </CardDescription>
              </div>
              <ChevronDown
                className={`h-5 w-5 text-muted-foreground transition-transform ${rateSheetOpen ? 'rotate-180' : ''}`}
              />
            </CollapsibleTrigger>
          </CardHeader>
          <CollapsibleContent>
            <CardContent>
              <RateSheetPreview locationId={locationId} />
            </CardContent>
          </CollapsibleContent>
        </Collapsible>
      </Card>

      <AssignPolicyDialog
        open={showAssignDialog}
        onOpenChange={setShowAssignDialog}
        locationId={locationId}
        existingAssignments={assignments}
      />
    </div>
  )
}
